<div class="boxWhite">
    <h4>CAMBIAR ESTADO</h4>

    <button class="btn btnClose" (click)="close()">
        <img src="assets/img/icoClose.svg" alt="">
    </button>

    <div class="contModal">
        <div class="row">
            <div class="col-sm-auto">
                <h6 class="clBlack">ID</h6>
                <p class="clGray mb-4">{{getConductor.visibleId}}</p>
            </div>
            <div class="col-sm">
                <h6 class="clBlack">nombre conductor</h6>
                <p class="clGray mb-4">{{getConductor.nombres}} {{getConductor.apellidoPaterno}}</p>
            </div>
            <!--div class="col-sm-3" *ngIf="estadoConductor === 'EN_COLACION'">
                <button class="btn btnImprimir" (click)="imprimirVoucherColacion()" [disabled]="loadingImprimir">
                    <img src="assets/img/icoPrint.svg" alt="">
                </button>
            </div-->
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="boxInsideModal bgLightGray mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>Estado Actual</h6>
                        <p class="clLightBlue m-0 fw-medium">{{getConductor.estado}}
                            <span class="clBlack">({{getTiempoEnEstadoHHmm}})</span>
                        </p>
                    </div>
                    <!--CON-1056: mientras el conductor siga en un estado con vale se puede reimprimir-->
                    <div class="d-flex flex-column justify-content-center" *ngIf="puedeReimprimirVale && tienePermisoCambiarEstado()">
                        <button class="btn btnImprimir" (click)="reimprimirValeEstado()" [disabled]="procesandoPdf || enviando" title="Reimprimir comprobante">
                            <span *ngIf="procesandoPdf" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <img *ngIf="!procesandoPdf" src="assets/img/icoPrint.svg" alt="">
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12 mb-4 select">
                <select class="form-select" [(ngModel)]="estadoConductor" (ngModelChange)="onEstadoSeleccionado()">
                    <option disabled value="SELECCIONE">Seleccionar Estado</option>
                    <option value="DISPONIBLE">Disponible</option>
                    <!--<option value="EN_CURSO">En Ruta</option>-->
                    <option value="EN_PATIO">Apoyo Patio</option>
                    <option *ngIf="colacionPermitida" value="EN_COLACION">
                        En Colacion
                    </option>
                    <option value="REVISION_TECNICA">En Rev Tecnica</option>
                    <!-- <option value="NO_DISPONIBLE">No Disponible</option> -->
                    <option value="CAPACITACION">Capacitación</option>
                    <option value="EN_TALLER">En Taller</option>
                </select>
            </div>
        </div>

        <!--CON-1056: duracion del estado. Fija y bloqueada en colacion, editable en los demas.-->
        <div class="row" *ngIf="configSeleccionada">
            <div class="col-sm-12 mb-4">
                <h6 class="clBlack">Duración</h6>
                <div class="d-flex align-items-center gap-2 duracionEstado">
                    <input type="number" class="form-control text-center" [(ngModel)]="duracionHoras"
                           (blur)="completarDuracion()" [disabled]="!duracionEditable"
                           min="0" max="23" step="1" placeholder="HH" aria-label="Horas">
                    <span class="fw-bold">:</span>
                    <input type="number" class="form-control text-center" [(ngModel)]="duracionMinutos"
                           (blur)="completarDuracion()" [disabled]="!duracionEditable"
                           min="0" max="59" step="1" placeholder="MM" aria-label="Minutos">
                </div>
            </div>
        </div>
    </div>

    <div class="footModal">
        <button *ngIf="tienePermisoCambiarEstado()" class="btn btnBlue w-100" [disabled]="enviando" (click)="cambiarEstado()">
            <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            GUARDAR
        </button>
    </div>

</div>